<i18n lang="yaml">
en:
  success: 'Copied connection command to clipboard'
  online: Online
  offline: Offline
ru:
  success: 'Команда для подключения к серверу по SSH скопирована в буфер обмена'
  online: Онлайн
  offline: Оффлайн
</i18n>

<script setup lang="ts">
import { useAlertStore } from '@/store'
import { useRouter } from 'vue-router'
import { useClipboard } from '@vueuse/core'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const router = useRouter()

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  ip: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  user_count: {
    type: Number,
    required: true
  },
  tags: {
    type: Array<String>,
    required: false
  },
  online: {
    type: Boolean,
    required: true
  },
  user: {
    type: String,
    required: true
  }
})

const command = computed(() => {
  return `ssh ${props.user}@${props.ip}`
})

const { t } = useI18n()
const alertStore = useAlertStore()
const { copy, isSupported } = useClipboard({ source: command })

async function edit() {
  await router.push({ name: 'servers:edit', params: { server_id: props.id } })
}

function connect() {
  if (isSupported.value) {
    copy()
    alertStore.success(t('success'))
  }
}
</script>

<template>
  <div @click="edit" class="card h-100 p-2">
    <div class="card-body">
      <img src="@/assets/server.svg" class="mb-2" />
      <img v-if="ip" @click.stop="connect" src="@/assets/link.svg" class="float-end" />
      <h5 class="card-title">
        {{ title }}
        <span v-if="online" class="badge rounded-pill bg-success">{{ t('online') }}</span>
        <span v-else class="badge rounded-pill bg-danger">{{ t('offline') }}</span>
      </h5>
      <h6 class="card-subtitle text-muted">{{ ip }}</h6>
      <div class="card-subtitle mt-1">
        <img src="@/assets/person.svg" class="mt-1 me-1" />
        <label class="mt-1 align-middle me-3">{{ user_count }}</label>
      </div>
      <p class="card-text">{{ description }}</p>
      <div>
        <span v-if="tags?.length" key="tag" v-for="tag in tags" class="badge bg-primary me-2">{{
          tag
        }}</span>
        <span v-else class="badge bg-info">No tags</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  /* border-radius: 4px; */
  background: #fff;
  transition:
    0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
  cursor: pointer;
}

.card:hover {
  transform: scale(1.01);
  box-shadow:
    0 10px 20px rgba(0, 0, 0, 0.12),
    0 4px 8px rgba(0, 0, 0, 0.06);
}
</style>
